"use client";

import type { UseNearbyLocationsParams } from "./types";

import { useQuery } from "@tanstack/react-query";
import { fetchNearbyLocations } from "./fetch-nearby-locations";

/**
 * React-query fetch wrapper for fetching nearby locations
 */
function useNearbyLocations({ config, ...params }: UseNearbyLocationsParams) {
  return useQuery({
    // Disable query if location is empty or enabled is explicitly false
    enabled: params.enabled !== false && Boolean(params.location?.trim()),
    queryFn: () => fetchNearbyLocations(params, config),
    queryKey: ["nearbyLocations", params, config?.apiEndpoint],
  });
}

export { useNearbyLocations };
